import React, { useState, useEffect } from 'react'
import { connect, useSelector, useDispatch } from 'react-redux'
import { Button, Col, Row } from 'reactstrap'
import { I18n } from 'react-redux-i18n'
import _isEmpty from 'lodash.isempty'
// import _uniqBy from 'lodash.uniqby'

import Step2SelectRecipients from './Step2SelectRecipients'
import Step2ImportExcel from './Step2ImportExcel'

import Recipients from './Recipients'
import { getTickets, getAdvancedTickets } from 'redux/actions/marketing'
import { lang } from 'utils/helpers'

const STEP_OPTIONS = {
  init: 'init',
  selectRecipients: 'selectRecipients',
  importExcel: 'importExcel',
}

const Step2 = () => {
  const dispatch = useDispatch(null)
  const campaign = useSelector((state) => state.marketing.campaign)

  const closeView = () => setStepOptions(STEP_OPTIONS.init)
  const [stepOptions, setStepOptions] = useState(STEP_OPTIONS.init)
  const [selectedUsers, setSelectedUsers] = useState([])
  const [showTable, setShowTable] = useState(false)
  // show users previously selected in campaign.filterTickets or campaign.advancedFilters
  const [previouslyFilteredUsers, setPreviouslyFilteredUsers] = useState([])

  const getCurrentFormStepOption = (option) => {
    const options = {
      init: '',
      selectRecipients: <Step2SelectRecipients campaign={campaign} closeView={closeView} sendUsers={showSelectedUsers} />,
      importExcel: <Step2ImportExcel closeView={closeView} additionalExcelUsers={addExcelUsers} />,
    }

    return options[option]
  }

  useEffect(() => {
    const { typeFilterUsed, advancedFilters, filterTickets, excelUsers } = campaign
    let notEmptyFilters = false
    let actionToCall = null
    let excludedUsers = []

    switch(typeFilterUsed) {
      case 'advancedFilters': {
        const existType = advancedFilters.type && advancedFilters.type.length

        notEmptyFilters = existType && advancedFilters.filters && advancedFilters.filters.find((el) => !_isEmpty(el))
        actionToCall = getAdvancedTickets()
        excludedUsers = advancedFilters.excludeTicketsId || []
        break
      }
      case 'filterTickets': {
        notEmptyFilters = !!Object.values(filterTickets).find((val) => val.length)

        actionToCall = getTickets(filterTickets)
        excludedUsers = filterTickets.excludeTicketsId || []
        break
      }
      default:
        break
    }

    if (!previouslyFilteredUsers.length && notEmptyFilters && actionToCall) {
      dispatch(actionToCall).then((data) => {
        // remove exludedIds users from Recipients view
        const filteredUsers = excludedUsers.length ? data.tableUsers.filter((user) => !excludedUsers.includes(user.id)) : data.tableUsers
        return setPreviouslyFilteredUsers(filteredUsers)
      })
    }

    if (excelUsers.length > 0) {
      addExcelUsers(excelUsers)
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  const showSelectedUsers = (users) => {
    setPreviouslyFilteredUsers(users)
    setSelectedUsers(users)
    setShowTable(true)
  }

  const addExcelUsers = (users) => {
    const excelUsers = users.map((user) => {
      const newUser = {
        fullName: `${user.name || ''} ${user.lastName || ''}`.trim(),
        state: '',
        channel: user.channel,
        createdAt: '',
        updatedAt: '',
      }
      return newUser
    })

    // update selectedUsers
    const totalUsers = previouslyFilteredUsers.concat(excelUsers)
    setSelectedUsers(totalUsers)
    setShowTable(true)
  }

  return (
    <>
      <h1>{I18n.t('campaign_step_user_segmentation')}</h1>
      <p className='summary'></p>

      {stepOptions === STEP_OPTIONS.init && (
        <Row>
          <Col>
            <Button
              outline
              color='primary'
              size='lg'
              onClick={() => setStepOptions(STEP_OPTIONS.selectRecipients)}
              className={'new-button with-shadow'}
            >
              <img src={'./img/icons/icon-user-primary.svg'} alt={'user'} />
              {I18n.t('dashboard_select-recipients')}
            </Button>
            <Button outline color='primary' size='lg' onClick={() => setStepOptions(STEP_OPTIONS.importExcel)} className={'new-button with-shadow'}>
              <img src={'./img/icons/icon-excel-primary.svg'} alt={'user'} />
              {I18n.t('import_excel')}
            </Button>
          </Col>
        </Row>
      )}

      {getCurrentFormStepOption(stepOptions)}

      {showTable && (
        <div>
          <p style={{ paddingTop: '15px' }}>
            <b>{lang('dashboard_count-selected-users', { count: selectedUsers.length })}</b>
          </p>
          <Recipients users={selectedUsers} handleSelectedUsers={() => null} fixed={true}></Recipients>
        </div>
      )}
      {previouslyFilteredUsers.length > 0 && !showTable && (
        <div>
          <p>
            <b>{lang('dashboard_count-selected-users', { count: previouslyFilteredUsers.length })}</b>
          </p>
          <Recipients
            users={previouslyFilteredUsers.length ? previouslyFilteredUsers : selectedUsers}
            handleSelectedUsers={() => null}
            fixed={true}
          ></Recipients>
        </div>
      )}
      {!showTable && !previouslyFilteredUsers.length && (
        <Row className='my-3'>
          <Col xs={12}>
            <div className='selected-users'>
              <p className='text-muted'>{I18n.t('dashboard_no-users-selected')}</p>
            </div>
          </Col>
        </Row>
      )}
    </>
  )
}

export default connect()(Step2)
